import { getErrorMessage, trim } from 'utils/stringUtils';

import { types } from './actions';

const initialState = {
  isUserInfoSaving: false,
  userInfoErrorMessage: null,
  userInfoSavedSuccess: false,
};

const reducer = (state = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case types.USER_INFO_INIT:
      return {
        ...initialState,
      };
    case types.USER_INFO_UPDATE_ERROR:
      return {
        ...state,
        isUserInfoSaving: false,
        userInfoErrorMessage: trim(getErrorMessage(payload), 70),
      };
    case types.USER_INFO_UPDATE_REQUEST:
      return {
        ...state,
        isUserInfoSaving: true,
        userInfoErrorMessage: null,
        wasUserInfoSavedSuccess: false,
      };
    case types.USER_INFO_UPDATE_SUCCESS:
      return {
        ...state,
        isUserInfoSaving: false,
        wasUserInfoSavedSuccess: true,
      };
    default:
      return state;
  }
};

export default reducer;

const getScope = (state) => state.modules.settings.userProfile.userInfo;

export const getUserInfoErrorMessage = (state) =>
  getScope(state).userInfoErrorMessage;

export const isUserInfoSaving = (state) => getScope(state).isUserInfoSaving;

export const wasUserInfoSavedSuccess = (state) =>
  getScope(state).wasUserInfoSavedSuccess;
